import S from 's-js';
import { IAjax, Request } from 'lib/Ajax';
import UOM from 'lib/UOM';
import { Entrypoints } from 'core/app/entrypoints';

import { PCCache } from 'data/PCCache';

import { BerthOptions, BerthData } from 'data/models/Berth';
import { PierSettings } from 'data/models/PierSettings';

export interface AddBerthParams {
    SchedulingAuthorityId : number | null;
}

export function AddBerth(
    ajax : IAjax,
    entrypoints : Entrypoints,
    data : PCCache,
    pierSettings : PierSettings,
    { SchedulingAuthorityId } : AddBerthParams
) {
    const client = ajax.Url<BerthOptions, BerthData>(entrypoints.AddBerth),
        request = S.data<Request<BerthData> | null>(null);

    return {
        Add
    };

    function Add() {
        if (request() && !request()!.Response()) return;
        const lengthUOM = pierSettings.DefaultLengthUOM() || UOM.Foot,
            req = client.Post({
                Id: 0,
                SchedulingAuthorityId,
                Location: {
                    Id: 0,
                    Name: 'New berth'
                },
                Length: {
                    Num: lengthUOM === UOM.Meter ? 30 : 100,
                    UOM: lengthUOM
                }
            });
        request(req);
        req.then(json => {
            data.Berths.update1(req.Date, json);
            window.location.hash = `#!berthprofile?id=${json.Id}&editName=true`;
        });
    }
}
export type AddBerth = ReturnType<typeof AddBerth>;


// WEBPACK FOOTER //
// ./apps/common/models/AddBerth.ts